import React from "react";
import { Reveal } from "./Reveal";
import { XIcon, CheckIcon } from "lucide-react";
const antes = ["Solo tienes una idea", "No sabes por dónde empezar", "Dudas sobre ingredientes y presentación", "No sabes cómo llamar tu marca", "Miedo a hacerlo mal", "Todo parece complicado"];
const despues = ["Una línea de sales de baño lista", "Un plan claro durante 7 días", "Todo organizado paso a paso", "Una marca con identidad propia", "Confianza para lanzar", "Sabes exactamente qué hacer cada día"];
const miniStats = [{
  value: "7",
  label: "Días"
}, {
  value: "6",
  label: "Tomos"
}, {
  value: "5",
  label: "Bonos"
}, {
  value: "100%",
  label: "Digital"
}];
export function Transformation() {
  return <section className="w-full bg-[#fbf5f0] px-5 py-14" data-id="element-231" data-mp="1aaxd3f1fj7lc">
      <div className="mx-auto max-w-xl text-center" data-id="element-232" data-mp="1fbl5o55b3who">
        <Reveal data-id="element-233" data-mp="1f8yxq4ei7eyx">
          <h2 className="font-serif-display text-2xl font-semibold leading-snug text-[#3d2b30] sm:text-3xl" data-id="element-234" data-mp="1k9wh2kb92f20">
            De una simple idea… <br data-id="element-235" data-mp="1c735cnpgy8hh" />
            <span className="italic text-[#a04a63]" data-id="element-236" data-mp="1c6thb5nzibef">a una línea lista para presentar</span>
          </h2>
          <p className="mx-auto mt-4 max-w-md text-sm leading-relaxed text-[#6b565b] sm:text-base" data-id="element-237" data-mp="175dtx6yc3ssv">
            En solo una semana dejarás de preguntarte “¿Cómo empiezo?” y terminarás con una
            colección de sales de baño que podrás mostrar con orgullo.
          </p>
        </Reveal>

        <div className="mt-10 grid gap-4 text-left sm:grid-cols-2" data-id="element-238" data-mp="1uw00etsox50r">
          <Reveal className="rounded-2xl border border-[#e7d3d8] bg-white p-6" data-id="element-239" data-mp="1quo7aealy1nt">
            <h3 className="mb-4 text-center text-sm font-extrabold uppercase tracking-wide text-[#9a7d84]" data-id="element-240" data-mp="1m3y1x126lyt4">
              Antes
            </h3>
            <ul className="space-y-3" data-id="element-241" data-mp="1h4bmckyvs6h5">
              {antes.map(item => <li key={item} className="flex items-start gap-2.5 text-sm text-[#6b565b]" data-id="element-242" data-mp="2ekqzqvifp9my">
                  <span className="mt-0.5 flex h-5 w-5 flex-shrink-0 items-center justify-center rounded-full bg-[#f0e0e4]" data-id="element-243" data-mp="29tim1na2n23z">
                    <XIcon className="h-3 w-3 text-[#9a7d84]" data-id="element-244" data-mp="2src5ccj8r384" />
                  </span>
                  {item}
                </li>)}
            </ul>
          </Reveal>

          <Reveal delay={0.1} className="rounded-2xl border-2 border-[#a04a63] bg-white p-6 shadow-lg shadow-[#a04a63]/10" data-id="element-245" data-mp="2jwnzol9r7jis">
            <h3 className="mb-4 text-center text-sm font-extrabold uppercase tracking-wide text-[#a04a63]" data-id="element-246" data-mp="2nxhm1a7jsq9k">
              Después del Kit
            </h3>
            <ul className="space-y-3" data-id="element-247" data-mp="2ez5ospc6eu85">
              {despues.map(item => <li key={item} className="flex items-start gap-2.5 text-sm font-semibold text-[#3d2b30]" data-id="element-248" data-mp="20yuxjl6yfdmg">
                  <span className="mt-0.5 flex h-5 w-5 flex-shrink-0 items-center justify-center rounded-full bg-[#a04a63]" data-id="element-249" data-mp="2506l7l69pos0">
                    <CheckIcon className="h-3 w-3 text-white" data-id="element-250" data-mp="3vdxg0yxl5vfv" />
                  </span>
                  {item}
                </li>)}
            </ul>
          </Reveal>
        </div>

        <Reveal delay={0.15} className="mt-8" data-id="element-251" data-mp="1ns5qi2n7i410">
          <div className="grid grid-cols-4 gap-2 rounded-2xl bg-[#a04a63] px-4 py-5 text-white" data-id="element-252" data-mp="1norncs6pxqsi">
            {miniStats.map(s => <div key={s.label} className="text-center" data-id="element-253" data-mp="1xhgytn29r4nu">
                <p className="font-serif-display text-2xl font-bold sm:text-3xl" data-id="element-254" data-mp="1xj0ebbg3pbok">{s.value}</p>
                <p className="text-[0.65rem] font-semibold uppercase tracking-wide text-[#f0dbe1]" data-id="element-255" data-mp="1so4897e14nsg">
                  {s.label}
                </p>
              </div>)}
          </div>
        </Reveal>
      </div>
    </section>;
}